
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'InfoTooltip',
  mixins: [staticBlockMixin],
  props: {
    iconBack: {
      type: Boolean,
      required: false,
      default: false
    },

    centered: {
      type: Boolean,
      required: false,
      default: false
    },

    asidePaddings: {
      type: Number,
      default: () => 0
    }
  }
})
